import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
   selector: 'app-dialog-confirm',
   templateUrl: './dialog-confirm.component.html',
   styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {

   msg:string
   title:string
   btn_cancel:string
   btn_confirm:string

   constructor(@Inject(MAT_DIALOG_DATA) public data: {title:string, msg:string, btn_confirm:string, btn_cancel:string}) {
      this.title = data.title || ''
      this.msg = data.msg || ''
      this.btn_cancel = data.btn_cancel || `Annulla`
      this.btn_confirm = data.btn_confirm || 'Conferma'
   }

   ngOnInit(): void {

   }

}
